import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// A month (1-12, or null when only the year is known) and a year.
const monthYearSchema = z.object({
  year: z.number().int().min(1950).max(2100),
  month: z.number().int().min(1).max(12).nullable(),
});

/**
 * Structured dates, entered like LinkedIn: start month and year, end month and year unless the
 * person still works there. Optional: `date` stays the text every template prints. Same shape as
 * ExperienceDates in @reactive-resume/utils (experience-dates.ts), shared with theRecruit.
 */
export const experienceDatesSchema = z.object({
  start: monthYearSchema.nullable(),
  end: monthYearSchema.nullable(),
  current: z.boolean(),
  source: z.enum(["entered", "parsed", "backfill"]),
});

// Schema
export const experienceSchema = itemSchema.extend({
  company: z.string().min(1),
  position: z.string(),
  location: z.string(),
  date: z.string(),
  dates: experienceDatesSchema.optional(),
  summary: z.string(),
  url: urlSchema,
});

// Type
export type Experience = z.infer<typeof experienceSchema>;

// Defaults
export const defaultExperience: Experience = {
  ...defaultItem,
  company: "",
  position: "",
  location: "",
  date: "",
  summary: "",
  url: defaultUrl,
};
